<template>
    <div class="whats-new-button-wrapper">
        <Button
            type="button"
            icon="pi pi-gift"
            severity="secondary"
            :aria-label="
                hasUnseen ? `What's New - ${unseenCount} unseen` : `What's New`
            "
            @click="open"
        />
        <Badge
            v-if="hasUnseen"
            :value="unseenCount"
            severity="danger"
            class="whats-new-badge"
            :title="`${unseenCount} new update(s)`"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import { useWhatsNewManager, useWhatsNewStore } from "@/stores/whats-new-store";

const store = useWhatsNewStore();
const { hasUnseen, unseenCount } = useWhatsNewManager();

// initDialog must be called during a component's setup() phase
store.initDialog();

const open = () => {
    store.openModal(true);
};

onMounted(() => {
    store.fetchUnseenEntries();
});
</script>

<style scoped lang="scss">
.whats-new-button-wrapper {
    position: relative;
    display: inline-flex;
}

.whats-new-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    pointer-events: none;
    transform: scale(0.85);
    transform-origin: top right;
}
</style>
